import { observer } from "mobx-react-lite"

import { Card } from "@/components/card"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/tooltip"
import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import { BodyXs } from "@/domains/design/components/body-xs"
import { cn } from "@/domains/library"
import { shortestValue } from "@/domains/library/shortest-value"

export const UserPosition = observer(
  ({ clFarm, className }: { clFarm: ClFarmStore | null | undefined; className?: string }) => {
    if (!clFarm || !clFarm?.connectedGauge) {
      return null
    }

    return (
      <Card.Container className={cn("p-4 lg:p-4", className)}>
        {/* <div> sunburst chart goes here</div> */}
        <div className="space-y-6 text-sm font-normal text-t200">
          <UserRow
            clFarm={clFarm}
            title="My Unstaked"
            lpValue={clFarm.userBalance}
            token0Value={clFarm.userBalanceToken0}
            token1Value={clFarm.userBalanceToken1}
          />
          <div className="border-b border-p400-light"></div>
          <UserRow
            clFarm={clFarm}
            title="My Staked"
            lpValue={clFarm.gaugeUserBalance}
            token0Value={clFarm.gaugeUserBalanceToken0}
            token1Value={clFarm.gaugeUserBalanceToken1}
          />

          <div className="border-b border-p400-light"></div>
          <UserRow
            clFarm={clFarm}
            title="Total Staked"
            lpValue={clFarm.onChainGaugeTotalSupply}
            token0Value={clFarm.onChainGaugeReserve0}
            token1Value={clFarm.onChainGaugeReserve1}
          />
        </div>
      </Card.Container>
    )
  },
)

const UserRow = observer(
  ({
    clFarm,
    title,
    lpValue,
    token0Value,
    token1Value,
  }: {
    clFarm: ClFarmStore
    title: string
    lpValue: bigint | 0n
    token0Value: bigint | 0n
    token1Value: bigint | 0n
  }) => {
    return (
      <div className="flex flex-row items-start justify-between gap-2">
        <BodyXs className="text-left text-t300">{title}</BodyXs>
        <div className="flex flex-col gap-1">
          <Position symbol={clFarm.displayName} value={clFarm.token1.formatUnits(lpValue)} decimals={clFarm.decimals} />
          <Position
            symbol={clFarm.token0.symbol}
            value={clFarm.token0.formatUnits(token0Value)}
            decimals={clFarm.token0.decimals}
          />
          <Position
            symbol={clFarm.token1.symbol}
            value={clFarm.token1.formatUnits(token1Value)}
            decimals={clFarm.token1.decimals}
          />
        </div>
      </div>
    )
  },
)

const Position = ({ symbol, value, decimals }: { symbol: string; value: string; decimals: number }) => {
  return (
    <div className="text-right hover:brightness-125">
      <Tooltip>
        <TooltipTrigger>
          <BodyXs As="span" className="text-t100">
            {shortestValue({
              value,
              decimals,
              minDecimals: 4,
              maxDecimals: 8,
            })}
          </BodyXs>{" "}
          <BodyXs As="span" className="text-t300">
            {symbol}
          </BodyXs>
        </TooltipTrigger>
        <TooltipContent className="text-t200">
          {value} {symbol}
        </TooltipContent>
      </Tooltip>
    </div>
  )
}
